import { ArrowLeft } from 'lucide-react'
import { Button } from '../ui/Button.js'
import { EmptyState } from '../data/EmptyState.js'

export interface NotHereProps {
  /** What the address pointed at — "member", "booking". */
  what: string
  /** Where the button goes back to — "Members". */
  backTo: string
  onBack: () => void
}

/**
 * 9.10, for a record: the address was fine, the thing it names is not there.
 *
 * Every record answered a missing id with *"That did not load … Try again"*,
 * which is the answer for a failed request and the wrong one for a link to
 * something removed or mistyped. Found walking the desk on 2026-09-27 by
 * typing addresses. The words are 9.10's own.
 */
export function NotHere({ what, backTo, onBack }: NotHereProps) {
  return (
    <EmptyState
      illustration="errors/something-went-wrong"
      title={`That ${what} is not here`}
      description="The link may be old, or the thing it pointed at may have been removed."
      action={
        <Button leadingIcon={<ArrowLeft />} onClick={onBack}>
          Back to {backTo}
        </Button>
      }
    />
  )
}
